export default __webpack_public_path__ + "static/media/update-icon.ef03aa47.svg";